<template>
  <wv-steak-house-default-section :section="section" :menu="menu"
                                  class="menu--section-two_column"></wv-steak-house-default-section>
</template>

<script lang="ts">
/**
 * Custom component for WV Steak House two column menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <WvSteakHouseTwoColumnSection> adds a two column layout for WV Steak House menu sections.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <WvSteakHouseTwoColumnSection>.
 *    - Remove "visual_" and "textual_" prefixes from class names in <WvSteakHouseTwoColumnSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import WvSteakHouseDefaultSection from "./WvSteakHouseDefaultSection.vue";

export default defineComponent({
  name: 'WvSteakHouseTwoColumnSection',
  components: {WvSteakHouseDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--section-two_column:deep(.menu--item_subgroup) {
  grid-gap: 1em;
}

.menu--section-two_column:deep(.menu--item) {
  grid-template-columns: 1fr 0.2fr;
}

.menu--section-two_column:deep(.menu--item_description) {
  margin-left: 0;
}
</style>